import { useMemo } from 'react';
import { useLocation } from '@/features/routing';
import { parsePathname } from '../../features/routing';
import { getDebugRing } from '../../lib/devUtils';
import { clx } from '../../lib/utils';
import { MoodLogTopBar } from './MoodLogTopBar';
import { useTopBarTransition } from './useTopBarTransition';

export const TopBar = ({ className }: { className?: string }) => {
  const pathname = useLocation();

  const parsedPathname = useMemo(() => {
    return parsePathname(pathname);
  }, [pathname]);

  const { topBarRef } = useTopBarTransition(parsedPathname);

  return (
    <div className={clx(className, getDebugRing('orange'))} ref={topBarRef}>
      {parsedPathname.section === 'mood-log-entry' && parsedPathname.stepNumber !== null && (
        <MoodLogTopBar currentStep={parsedPathname.stepNumber} />
      )}
    </div>
  );
};
